const hasKey = <O extends object>(obj: O, key: PropertyKey): key is keyof O => key in obj;

const createHasFieldBeenTracked = () => ({
  first_name: false,
  last_name: false,
  number: false,
  month: false,
  year: false,
  cvv: false,
  postal_code: false,
});

export { hasKey, createHasFieldBeenTracked };
